export type Author = {
  name: string;
  slug: string;
  avatar: string;
  bio: string;
  role: string;
  socialLinks: {
    label: string;
    url: string;
  }[];
  sameAs: string[];
};

export const authors: Author[] = [
  {
    name: "Raka Pranata",
    slug: "raka-pranata",
    avatar: "/images/author-raka.svg",
    role: "Knowledge Editor",
    bio: "Raka edits practical technology explainers and keeps yawiki.org articles concise, sourced, and easy to scan.",
    socialLinks: [
      { label: "Website", url: "https://yawiki.org/author/raka-pranata" },
      { label: "GitHub", url: "https://github.com/yawiki" }
    ],
    sameAs: ["https://github.com/yawiki"]
  },
  {
    name: "Maya Lestari",
    slug: "maya-lestari",
    avatar: "/images/author-maya.svg",
    role: "Research Writer",
    bio: "Maya focuses on evergreen web, content, and research systems for small editorial teams.",
    socialLinks: [
      { label: "Website", url: "https://yawiki.org/author/maya-lestari" },
      { label: "X", url: "https://x.com/yawiki" }
    ],
    sameAs: ["https://x.com/yawiki"]
  }
];

export function getAuthor(slug: string) {
  return authors.find((author) => author.slug === slug);
}
